export default __webpack_public_path__ + "static/media/crud.7cb998b5.gif";